import { render, staticRenderFns } from "./BjdCodeSelectComponent.vue?vue&type=template&id=6643893e&scoped=true&"
import script from "./BjdCodeSelectComponent.vue?vue&type=script&lang=js&"
export * from "./BjdCodeSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./BjdCodeSelectComponent.vue?vue&type=style&index=0&id=6643893e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643893e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
